export default {
  themeName: 'default',
}
